import React from 'react'

import { useBrandsQuery } from '@sentecacommerce-theme/lib'
import styled from 'styled-components'
import { Heading } from '../Common'

import { BrandList } from './Components'
import { BrandsProps } from './brands.props'

export const BrandsComponent = ({ labels }: BrandsProps) => {
  const { data } = useBrandsQuery()

  const mappedBrands = React.useMemo(() => {
    return data?.terms[0]?.results
      ?.map((agg: any) => {
        const { meta } = agg || {}

        if (meta?.assets?.every((x: any) => x.key !== 'thumbnail')) {
          return false
        }

        const brandPageUrl = meta?.['custom-brandPageUrl']
        let slug = `/${meta?.slug?.[0]?.value}/b`
        if (brandPageUrl) {
          slug = brandPageUrl
        }
        return {
          name: meta?.name?.[0]?.value,
          slug,
          isFeatured: Boolean(meta['custom-isFeatured']),
          logo: meta?.assets?.find((x: any) => x.key === 'thumbnail')
            ?.sources?.[0]?.url,
        }
      })
      .filter(Boolean)
  }, [data?.terms])

  const featured = mappedBrands?.filter((x: any) => x.isFeatured)
  const nonFeatured = mappedBrands?.filter((x: any) => !x.isFeatured)

  return (
    <div className="container">
      <Heading as="h2" data={labels?.leadingBrands} topTitle className="mb-4" />
      <Section>
        <BrandList brands={featured} />
      </Section>
      <Heading as="h1" data={labels?.allBrands} topTitle className="mb-4" />
      <Section>
        <BrandList brands={nonFeatured} />
      </Section>
    </div>
  )
}

const Section = styled.section.attrs({
  className: 'row g-4',
})``
